// The two things the board offers besides jobs, placed inside the list where
// they are useful instead of as sections of their own: what the role pays,
// and the Co-pilot for people who do not know what to search. Plus the
// bottom of the page: browse links (for people and for search engines) and
// the saved-search signup.
import { Link } from "react-router-dom";
import { LANDING_PAGES } from "@/seo/landingPages";
import { payFamilyFor, type PayFamily } from "@/hooks/useHomeLive";
import AlertsForm from "./AlertsForm";

const k = (v: number) => `$${(Math.round(v / 100) / 10).toString().replace(/\.0$/, "")}k`;

export function BoardPayCard({ query, families }: { query: string; families?: Record<string, PayFamily> }) {
  if (!families) return null;
  const name = payFamilyFor(query);
  const fam = name ? families[name] : undefined;
  const use = fam && fam.n >= 30 ? { label: `Remote ${name} roles`, fam } : families.All ? { label: "Remote accounting and finance roles", fam: families.All } : null;
  if (!use) return null;
  return (
    <div className="bh-card bh-card--pay">
      <div className="bh-card__text">
        <p className="bh-card__k">Your pay, measured</p>
        <p className="bh-card__h">{use.label} post a median of {k(use.fam.med)}. The middle half pays {k(use.fam.p25)} to {k(use.fam.p75)}.</p>
        <p className="bh-card__s">From {use.fam.n.toLocaleString("en-US")} remote postings with a stated annual range, updated every 15 minutes.</p>
      </div>
      <Link to="/tools/salary-research" className="bh-card__btn bh-card__btn--yellow">See where you land</Link>
    </div>
  );
}

export function BoardCopilotCard({ onOpen }: { onOpen: () => void }) {
  return (
    <div className="bh-card bh-card--copilot">
      <div className="bh-card__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round"><path d="M4 12h16M12 4l8 8-8 8" /></svg>
      </div>
      <div className="bh-card__text">
        <p className="bh-card__h bh-card__h--dark">Not sure what to search for?</p>
        <p className="bh-card__s bh-card__s--dark">Answer eleven questions and we build your shortlist, including roles that never reach the job boards. About two minutes, no account.</p>
      </div>
      <button type="button" className="bh-card__btn bh-card__btn--outline" onClick={onOpen}>Start the Co-pilot</button>
    </div>
  );
}

type AlertProps = {
  effectiveTitle: string;
  urlLocation: string;
  urlRemote: boolean;
  urlInternship: boolean;
  urlContract: boolean;
  urlPartTime: boolean;
};

export function BoardBrowse(props: AlertProps) {
  return (
    <section className="bh-browse" aria-label="Browse and alerts">
      <div className="container bh-browse__grid">
        <div>
          <h2 className="bh-browse__h">Browse jobs by role</h2>
          <ul className="bh-browse__links">
            {LANDING_PAGES.map((p) => (
              <li key={p.path}><Link to={p.path}>{p.heading}</Link></li>
            ))}
          </ul>
        </div>
        <div className="bh-browse__alert">
          <h2 className="bh-browse__h">Get new roles by email</h2>
          <p className="bh-browse__p">Save this search and we email the new matches, daily or weekly. Stop any time.</p>
          <AlertsForm {...props} />
        </div>
      </div>
    </section>
  );
}
